import {
  Component,
  Output,
  ViewChild,
  EventEmitter,
  OnDestroy,
  inject,
} from '@angular/core';
import { AuthService } from 'src/app/Services/auth.service';
import { AuthUser, Login } from 'src/app/Entities';
import { MenuService } from 'src/app/Services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css'],
})
export class TopbarComponent implements OnDestroy {
  private router = inject(Router);
  @Output() onShowModalLogin = new EventEmitter();

  fecha: Date = new Date();
  date_interval;
  constructor(
    public authService: AuthService,
    private menuService: MenuService
  ) {
    this.date_interval = setInterval(() => {
      this.fecha = new Date();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.date_interval);
  }

  cerrarSesion() {
    this.authService.authUser = new AuthUser();
    this.menuService.setMenu([]);
    this.router.navigate(['/']);
    this.authService.clearSesion();
  }

  showLoginModal() {
    this.onShowModalLogin.emit();
  }
}
